
export const styles = theme => ({
    container: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '400px',
      justifyContent: 'center',
      left: '50%',
      outline: 'none',
      position: 'absolute',
      textAlign: 'center',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      padding: theme.spacing(3),
      boxShadow: theme.shadows[3]
    }
  });